import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_2 = { class: "grid grid-cols-12 gap-6" }

import DefaultInput from '../components/DefaultInput.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import PostalCode from '../components/PostalCode.vue';

import { useCurrentClient } from '../composables/useCurrentClient';

import { PROVINCES } from '../utils/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerProfileDisplay',
  setup(__props) {

const { currentClient } = useCurrentClient();

return (_ctx: any,_cache: any) => {
  return (_unref(currentClient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mb-4 flex justify-between" }, [
          _createElementVNode("h2", { class: "font-bold text-gray-900" }, "Dane osobowe")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DefaultInput, {
            class: "col-span-6",
            "model-value": _unref(currentClient).first_name,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Imię* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-6",
            "model-value": _unref(currentClient).last_name,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Nazwisko* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-6",
            "model-value": _unref(currentClient).email,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" E-mail* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-6",
            "model-value": _unref(currentClient).phone,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Numer telefonu* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-8",
            "model-value": _unref(currentClient).street,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Adres* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-2",
            "model-value": _unref(currentClient).house_number,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Numer domu* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultInput, {
            class: "col-span-2",
            "model-value": _unref(currentClient).apartment_number,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Numer mieszkania ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(DefaultSelect, {
            class: "col-span-2",
            "model-value": _unref(currentClient).province,
            options: _unref(PROVINCES),
            placeholder: "Wybierz",
            filter: "",
            disabled: ""
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Województwo* ")
            ])),
            _: 1
          }, 8, ["model-value", "options"]),
          _createVNode(DefaultInput, {
            class: "col-span-8",
            "model-value": _unref(currentClient).city,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Miejscowość* ")
            ])),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(PostalCode, {
            class: "col-span-2",
            "model-value": _unref(currentClient).postal_code,
            disabled: ""
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Kod pocztowy* ")
            ])),
            _: 1
          }, 8, ["model-value"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})